'use client'

import {
  Button,
  Container,
  Section,
  SectionHeaderContent
} from '@/ui/components'
import { useEffect } from 'react'

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])
  return (
    <>
      <Section>
        <SectionHeaderContent as="h2">
          Ops! something went wrong
        </SectionHeaderContent>
        <Container>
          <p>Please try again later, or contact support.</p>
          <div className="gap-xs mt-lg flex">
            <Button onClick={() => reset()}>Try again</Button>
            <Button
              nextLink={false}
              as="a"
              variant="secondary"
              href="mailto:support@spotagency.it"
            >
              Contact support
            </Button>
          </div>
        </Container>
      </Section>
    </>
  )
}
